// The legal entity, in one place. Mirrors common/config/params.php['company'] —
// keep the two in step when either changes.
//
// Before this the address existed in four different wordings: params.php, the
// invoice template ("Hustlebub Tech Park, Somasundarapalya Main Road"), the
// footer, and the contact/become-partner pages (which gave no street at all).
// The Terms of Use now publish the address, so the site should agree with it.
export const COMPANY = {
  name: "Travelware Technologies Private Limited",
  shortName: "Travelware Technologies Pvt. Ltd.",

  // Corporate office — where the business operates, and the place of business
  // the GSTIN (29 = Karnataka) is registered against.
  addressLines: [
    "2nd Floor, 36/5, Somasundarapalya,",
    "27th Main Road, Sector 2, HSR Layout,",
    "Bengaluru, Karnataka 560102",
  ],

  // Registered office per the MCA record against the CIN (MH = Maharashtra).
  // Named separately in the Terms; not the operating address.
  registeredAddress:
    "House No. 385, Near Mico Wall, MHB Colony, Nashik, Maharashtra 422007",

  cin: "U63031MH2020PTC339052",
  gstin: "29AAHCT8228R1ZB",

  email: "contact@sukuto.com",

  // Publishing a named grievance officer with contact details is required by the
  // Consumer Protection (E-Commerce) Rules 2020 r.4(5) and the IT Rules 2021
  // r.3(2) — it has to be findable site-wide, not only inside the Terms.
  grievanceOfficer: {
    name: "Chandan Singh",
    email: "contact@sukuto.com",
    ackHours: 48,
    resolveDays: 30,
  },
  phone: "+91-8884414400",
  phoneHref: "tel:+918884414400",

  mapsUrl:
    "https://maps.google.com/?q=Travelware+Technologies+Private+Limited+HSR+Layout+Bengaluru+Karnataka+560102",
};

export const companyAddress = COMPANY.addressLines.join(" ");

export default COMPANY;
